<body>

    <div class="container">
        <div class="receipt-details">
            <p>Receipt No: 123456</p>
            <p>Date: October 17, 2023</p>
            <p>{{FeeData}}</p>
        </div>

        <div class="item col-sm-2">
            <p *ngFor="let item of FeesData">{{item.FeeHead}}</p>
        </div>

        <div class="items">
            <div class="item col-sm-2">
                <div *ngFor="let item of FeesData" class="item-name">{{item.FeeHead}}</div>
                <div class="item-price">$10.00</div>
            </div>
            <div class="item">
                <div class="item-name">Item 2</div>
                <div class="item-price">$15.00</div>
            </div>
        </div>
        <div class="total">
            <p>Total: $25.00</p>
            
        </div>
    </div>

</body>